import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const calculateExpectedEarnings = (amount = 0, estimateDays = 1) => {
  const estimatedMinutes = estimateDays * 24 * 60;
  const minutesSinceToday = (dayjs.utc().hour() * 60) + dayjs.utc().minute();
  return (amount / minutesSinceToday) * estimatedMinutes;
}